import AISimilarTickets from './AISimilarTickets';

export default AISimilarTickets;
